async function downloadFile(url, fileName, idToken) {
  document.body.style.cursor = "wait";
  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${idToken}`,
      },
    });

    if (!response.ok) {
      throw new Error(
        `Download failed: ${response.status} ${response.statusText}`
      );
    }

    const blob = await response.blob();

    const objectUrl = URL.createObjectURL(blob);

    // Build a hidden <a> element pointing at the object URL
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a); // required for Firefox
    a.click();

    // Clean up: revoke the object URL and remove the element
    setTimeout(() => {
      URL.revokeObjectURL(objectUrl); // free memory
      a.remove();
    }, 100); // short delay ensures the download has started
  } finally {
    document.body.style.cursor = "auto";
  }
}

export default downloadFile;
